import { render, staticRenderFns } from "./CoordinatePrompt.vue?vue&type=template&id=ad16141e"
import script from "./CoordinatePrompt.vue?vue&type=script&lang=ts"
export * from "./CoordinatePrompt.vue?vue&type=script&lang=ts"
import style0 from "./CoordinatePrompt.vue?vue&type=style&index=0&id=ad16141e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports